import { render, staticRenderFns } from "./QuestionForm.vue?vue&type=template&id=36cb61ae&scoped=true&"
import script from "./QuestionForm.vue?vue&type=script&lang=js&"
export * from "./QuestionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cb61ae",
  null
  
)

export default component.exports